import React from 'react'
import {
  TwitterTimelineEmbed,
  TwitterShareButton,
  TwitterFollowButton,
  TwitterHashtagButton,
  TwitterMentionButton,
  TwitterTweetEmbed,
  TwitterMomentShare,
  TwitterDMButton,
  TwitterVideoEmbed,
  TwitterOnAirButton,
} from "react-twitter-embed";

const About = () => {
  return (
    <>
      <section className="">
        <h1 className="text-center mt-5">ABOUT US</h1>
        <div
          className="tweet__container"
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            // width: "600px",
          }}
        >
          <TwitterTweetEmbed
            className="tweet__container"
            options={{ theme: "dark" }}
            tweetId={"1686294836393947136"}
            placeholder="Loading Bull NFTs Tweet..."
          />
        </div>
      </section>
    </>
  );
}

export default About